export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // {
  //   field: 'checkbox',
  //   width: 40,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'checkbox',
  // },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_amzFlipOrderNo') || '翻单需求编号',
    field: 'amzFlipOrderNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_title') || '翻单需求标题',
    field: 'title',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzMarketName') || '翻单市场区域',
    field: 'amzMarketName',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_flipOrderType') || '翻单类型',
    field: 'skuSalesChannel',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'skuSalesChannel' },
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'amzFlipOrderStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    width: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
